console.log("working");

document.addEventListener('DOMContentLoaded', function () {
    var elem = document.querySelector("#nav a");
    var form = document.querySelector("form");
    var parent = document.querySelector("#login");

    var new_elem = document.createElement("p");
    new_elem.classList.add("intro");
    new_elem.innerHTML = "Welcome to My Life Well Lived </br></br> This website is password protected and only viewable to authorised users. </br></br> To get started please enter your login information";

    parent.insertBefore(new_elem, form);
    elem.innerHTML = "I forgot my password";
  });


// WEBPACK FOOTER //
// ./scripts/login.js